import { render, staticRenderFns } from "./manager.vue?vue&type=template&id=25d70db2&scoped=true&"
import script from "./manager.vue?vue&type=script&lang=js&"
export * from "./manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d70db2",
  null
  
)

export default component.exports